<template>
  <div class="banners">
    <div class="wholesale_programme_title">
      <div class="wholesale_programme_title_text" style="width: 420px">
        基于物联网技术的无人值守系统
        <img src="../../assets/img/title3@2x.png" alt="" />
      </div>
      <div class="zhexian"></div>
      <div class="zhexian_text">
        无人值守、无感支付、智能车牌识别、灵活缴费配置
      </div>
    </div>
    <div class="loadometer_top">
        <img src="../../assets/img/db_1@2x.png" alt="">
    </div>

    <div class="loadometer_b">
      <p>您的市场停车管理是否也遇到过这些问题?</p>
      <div class="loadometer_b_box">
        <div>运营人力成本高</div>
        <div>管理难度大</div>
        <div>信息化水平低</div>
      </div>
    </div>

    <div class="wholesale_programme_title">
      <div
        class="wholesale_programme_title_text"
        style="width: 150px; margin-top: 71px"
      >
        我们的优势
        <img src="../../assets/img/title3@2x.png" alt="" />
      </div>
      <div class="zhexian" style="margin-bottom: 40px"></div>
    </div>
    <div style="width: 1200px; margin: 0 auto; margin-bottom: 40px">
      <img
        style="width: 1200px; height: 512px"
        src="../../assets/img/ys@2x.png"
        alt=""
      />
    </div>

    <div class="loadometer_font">
      <div class="wholesale_programme_title">
        <div
          class="wholesale_programme_title_text"
          style="width: 510px; margin-top: 61px"
        >
          禾平数据无人值守停车方案能为您带来
          <img src="../../assets/img/title3@2x.png" alt="" />
        </div>
        <div class="zhexian" style="margin-bottom: 50px"></div>
      </div>
      <div
        style="
          width: 1200px;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;
        "
      >
        <div class="font_box">
          <div class="font_box_img">
            <img src="../../assets/img/tc_1@2x.png" alt="" />
          </div>
          <div class="font_box_center">
            <p>企业收益</p>
            <i
              >采用禾平数据全套停车场解决方案，为您带来更高效益，全面提升车场智能化管理的同时，还能够带来可量化的经济效益</i
            >
            <div
              style="
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
              "
            >
              <span>效益提升</span>
              <span>车位周转</span>
              <span>节省成本</span>
            </div>
            <div style="display: flex; margin-top: 8px">
              <span>解决拥堵</span>
              <span style="margin-left: 8px">车场增收</span>
            </div>
          </div>
        </div>
        <div class="font_box">
          <div class="font_box_img">
            <img src="../../assets/img/tc_2@2x.png" alt="" />
          </div>
          <div class="font_box_center">
            <p>车主服务</p>
            <i
              >为您的车主提供更多便捷的自助服务平台, 提升办事效率, 享受更高效且更经济实惠的停车体验</i
            >
            <div
              style="
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
              "
            >
              <span>电子支付</span>
              <span>线上包月</span>
              <span>电子发票</span>
            </div>
            <div style="display: flex; margin-top: 8px">
              <span>预约停车</span>
              <span style="margin-left: 8px">错峰停车</span>
            </div>
          </div>
        </div>
        <div class="font_box">
          <div class="font_box_img">
            <img src="../../assets/img/tc_3@2x.png" alt="" />
          </div>
          <div class="font_box_center">
            <p>更多收益</p>
            <i
              >禾平数据无人值守停车方案还可以为您提供全套方案落地实施服务、软件平台定期维护升级、贴心产品售后支持等</i
            >
            <div
              style="
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
              "
            >
              <span>专属实施</span>
              <span>定制服务</span>
              <span>技术支持</span>
            </div>
            <div style="display: flex; margin-top: 8px">
              <span>系统集成</span>
              <span style="margin-left: 8px">品牌设备</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created(){
       this.$store.commit("solutions", -1);
      this.$store.commit("solutions", 2);                                                                                                                                                                    
  }
};
</script>
<style scoped>
.wholesale_programme_title {
  width: 1200px;
  margin: 0 auto;
}
.wholesale_programme_title_text {
  text-align: center;
  margin: 0 auto;
  position: relative;
  font-size: 30px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
}
.wholesale_programme_title_text img {
  width: 32px;
  height: 32px;
  position: absolute;
  top: -8px;
  right: -15px;
}
.zhexian {
  width: 60px;
  height: 2px;
  background: #333333;
  margin: 0 auto;
  margin-top: 16px;
}
.zhexian_text {
  text-align: center;
  margin-top: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}

.loadometer_top {
  width: 1200px;
  height: 500px;
  margin: 0 auto;
  margin-bottom: 50px;
  margin-top: 50px;
}
.loadometer_top img{
    width: 1200px;
    height: 500px;
}
.loadometer_b {
  width: 100%;
  height: 345px;
  background: #f7fbff;
  border-radius: 4px;
  overflow: hidden;
}
.loadometer_b p {
  font-size: 30px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  text-align: center;
  line-height: 42px;
  margin-top: 50px;
  margin-bottom: 50px;
  display: block;
}
.loadometer_b_box {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
}
.loadometer_b_box div {
  width: 384px;
  height: 153px;
  background: linear-gradient(180deg, #5f96f5 0%, #2b5db3 100%);
  box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  text-align: center;
  line-height: 153px;
  font-size: 24px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
}
.loadometer_font {
  width: 100%;
  height: 517px;
  background: #f7fbff;
  border-radius: 4px;
  overflow: hidden;
}
.font_box {
  width: 384px;
  height: 296px;
  background: linear-gradient(136deg, #5f96f5 0%, #2b5db3 100%);
  box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  overflow: hidden;
  cursor:pointer;
}
.font_box:hover {
  background: linear-gradient(137deg, #77f3c1 0%, #18b394 100%);
}
.font_box_img {
  width: 50px;
  height: 50px;
  border: 1px solid #ffffff;
  border-radius: 50%;
  margin: 0 auto;
  margin-top: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.font_box_img img {
  width: 30px;
  height: 30px;
}
.font_box_center {
  width: 316px;
  margin: 0 auto;
}
.font_box_center p {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  line-height: 18px;
  text-align: center;
  margin-top: 16px;
  margin-bottom: 16px;
}
.font_box_center i {
  height: 66px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 22px;
  display: block;
  margin-bottom: 16px;
}
.font_box_center span {
  display: inline-block;
  width: 100px;
  height: 29px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  line-height: 29px;
}
</style>